import "./Dropdown.scss";
import { FunctionComponent } from "react";
import Select from "react-select";

interface IProps {
  label?: string;
  options: any;
  placeholder: string;
  value?: any;
  defaultValue?: any;
  onChange: any;
  className?: string;
  isMulti?: boolean;
  innerRef?: any;
  onFocus?: any;
  onInputChange?: any;
  infoIcon?: boolean;
  infoMessage?: string;
}

const Dropdown: FunctionComponent<IProps> = (props) => {
  const {
    defaultValue,
    label,
    onChange,
    options,
    placeholder,
    isMulti,
    className,
    value,
    innerRef,
    onFocus,
    onInputChange,
    infoIcon, 
    infoMessage
  } = props;

  return (
    <div className="dropdown-container">
      <div className="label-info">
        {label && <label>{label}</label>}
        {infoIcon && 
          <span className="info-icon">
            <span className="icon-question"></span>
            <span className="tooltip">{infoMessage}</span>
          </span>
        }
      </div>
      <Select
        ref={innerRef}
        className={"basic-single " + className}
        classNamePrefix="select"
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isRtl={false}
        isSearchable={true}
        options={options}
        value={value}
        onChange={onChange}
        defaultValue={defaultValue}
        onFocus={onFocus}
        onInputChange={onInputChange}
      />
    </div>
  );
};

export default Dropdown;
